module.exports = __webpack_public_path__ + "img/sticker.4eaf4863.svg";